import React, {PureComponent} from 'react';

import Input from '../../components/Input';

import SubConfiguration from './SubConfiguration';

class DefaultAnswers extends PureComponent {
  renderForm() {
    const {question, onChange} = this.props;
    const {defaultAnswers} = question;

    switch (question.type) {
      case 'NUMERIC':
        return (
          <Input
            type="number"
            step="any"
            placeholder="Enter the default answer"
            defaultValue={defaultAnswers[0]}
            onBlur={e => onChange([e.target.value])}
          />
        );

      case 'BOOLEAN':
        return (
          <Input
            type="select"
            value={defaultAnswers[0]}
            onChange={e => onChange([e.target.value])}>
            <option>Choose the default answer</option>
            <option value="true">Yes (True)</option>
            <option value="false">No (False)</option>
          </Input>
        );
      
      case 'TEXT':
        return (
          <Input
            type="text"
            placeholder="Enter the default answer"
            defaultValue={defaultAnswers[0]}
            onBlur={e => onChange([e.target.value])}
          />
        );

      default:
        throw new Error(`Unhandled default answer type: ${question.type}`)
    }
  }

  render() {
    return (
      <SubConfiguration>
        <SubConfiguration.Item>
          {this.renderForm()}
        </SubConfiguration.Item>
      </SubConfiguration>
    );
  }
}

export default DefaultAnswers;